import parsePhoneNumber, { AsYouType as PhoneNumberFormatterAsYouType } from "libphonenumber-js";

export function zodPhoneNumberRefine(fieldName: string, errorMessage: string = "Please enter a valid phone number") {
  return (data: any) => {
    if (!data) { return false; }
    const phoneValue = data[fieldName];

    if (!phoneValue || (typeof phoneValue === 'string' && !phoneValue.trim())) {
      return true; // Optional field, empty is valid
    }

    if (typeof phoneValue !== 'string') {
      return false;
    }

    const parsedNumber = parsePhoneNumber(phoneValue, 'US');
    return parsedNumber?.isPossible() ?? false;
  };
}

export function parsePhoneNumberToE164Strict(value: string | undefined): string | undefined {
  if (!value || typeof value !== 'string' || !value.trim()) {
    return undefined;
  }

  const parsedNumber = parsePhoneNumber(value, 'US');
  return parsedNumber?.isValid() ? parsedNumber.format('E.164') : undefined;
}

/**
 * Formats a stored (E.164) phone number for display: "(515) 555-0100" for US numbers,
 * international format otherwise. Falls back to the raw value when it can't be parsed.
 */
export function formatPhoneForDisplay(value: string): string {
  const parsedNumber = parsePhoneNumber(value, 'US');
  if (!parsedNumber) return value;
  return parsedNumber.country === 'US' ? parsedNumber.formatNational() : parsedNumber.formatInternational();
}

/**
 * Formats the raw input using AsYouType for US numbers.
 * The user does NOT need to type +1 — we treat all input as US.
 * If they paste something with +1 it still formats correctly.
 * Pass the field's `previous` value so backspacing over formatting characters works.
 */
export function formatPhoneAsYouType(raw: string, previous?: string): string {
  // Strip the +1 prefix so AsYouType formats as a national number
  let digits = raw.replace(/[^\d+]/g, "");
  // Backspacing over formatting only (e.g. the ")" of "(515)") would get it re-added; drop a digit instead.
  if (previous !== undefined && raw.length < previous.length && digits === previous.replace(/[^\d+]/g, "")) {
    digits = digits.slice(0, -1);
  }
  if (digits.startsWith("+1")) {
    digits = digits.slice(2);
  } else if (digits.startsWith("1") && digits.length > 10) {
    digits = digits.slice(1);
  }

  const formatter = new PhoneNumberFormatterAsYouType("US");
  return formatter.input(digits);
}
